<template>
<div class="chapter">
<div class="inner_page">
<p class="OT">Contents</p>
<p class="Toc1" id="int-001"><a href="#/xhtml/introduction#int001"><i>Introduction</i></a></p>
<p class="Toc2" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.  Frame | Rule of Life</a></p>
<p class="Toc2" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.  Wheels | Habit</span></p>
<p class="Toc2" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.  Saddle | Endurance</span></p>
<p class="Toc2" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.  Tires and Tubes | Border-Crossing</span></p>
<p class="Toc2" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.  Lights | Visibility</span></p>
<p class="Toc2" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.  Fork | Rest</span></p>
<p class="Toc2" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.  Handlebars | Adaptation</span></p>
<p class="Toc2" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.  Gears | Pacing</span></p>
<p class="Toc2" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.  Chain | Embodiment</span></p>
<p class="Toc" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">10.  Helmet | Particularity</span></p>
<p class="Toc" id="ch-011"><span href="#/xhtml/chapter011#ch011" title="Link target outside of Sample">11.  Brakes | Limitations</span></p>
<p class="Toc" id="ch-012"><span href="#/xhtml/chapter012#ch012" title="Link target outside of Sample">12.  You | Joy</span></p>
<p class="Toc10" id="bm-001"><span href="#/xhtml/backmatter001#bm001" title="Link target outside of Sample">Blessing of the Bicycles Service</span></p>
<p class="Toc10" id="bm-002"><span href="#/xhtml/backmatter002#bm002" title="Link target outside of Sample">Ghost Bike Service</span></p>
<p class="Toc10" id="not-001"><span href="#/xhtml/notes#not001" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="Toc10" id="ack-001"><span href="#/xhtml/acknowledgments#ack001" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="image"><img alt="pix" src="images/pix.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?ff806c90